import React, { useEffect, useState } from 'react';
import { get_listeEnergie } from '../api/energie';
import { message, Select } from 'antd';
const { Option } = Select;


const ListeEnergie = ({ onchange, valeur }) => {
  const [ListeEnergie, setListeEnergie] = useState([]);
  console.log(valeur);
  useEffect(() => {
    fetchListeEnergie();
  }, []);



  const fetchListeEnergie = async () => {
    const res = await get_listeEnergie();
    if (res.status === "success") {
      setListeEnergie(res.data);
    } else {
      message.warning('Aucune énergie trouvée !');
    }
  };

  return (
    <div>
      <Select
        size="medium"
        style={{
          width: '100%',
          textAlign: "center"
        }}
        value={valeur && valeur !== 0 ? valeur : null} 
        placeholder="Choisir une énergie"
        onChange={(value) => {
          if (onchange) onchange(value); // appel du parent
        }}
      >
        {
          ListeEnergie && ListeEnergie.map(item => (
            <Option key={item.id} value={item.id}>
              {item.nom}
            </Option>
          ))
        }
      </Select>
    </div>
  );
};

export default ListeEnergie;
